import { getLocalStorageItem, setLocalStorageItem } from '@/utils/storage';

export interface GullakDrawerCacheValue {
  balance: number | null;
  gullakCash: number | null;
}

export const getGullakDrawerBalanceCacheKey = (userId: string | number) => {
  return `gullak_drawer_balance_${userId}`;
};

export const getGullakDrawerCashCacheKey = (userId: string | number) => {
  return `gullak_drawer_cash_${userId}`;
};

export const getGullakDrawerCache = (userId: string | number): GullakDrawerCacheValue => {
  const balance = getLocalStorageItem(getGullakDrawerBalanceCacheKey(userId));
  const gullakCash = getLocalStorageItem(getGullakDrawerCashCacheKey(userId));

  return {
    balance: balance === null ? null : Number(balance),
    gullakCash: gullakCash === null ? null : Number(gullakCash),
  };
};

export const setGullakDrawerCache = (
  userId: string | number,
  payload: { balance: number; gullakCash: number; }
) => {
  setLocalStorageItem(getGullakDrawerBalanceCacheKey(userId), payload.balance.toString());
  setLocalStorageItem(getGullakDrawerCashCacheKey(userId), payload.gullakCash.toString());
};
